import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_IDENTIFICATION: GlameraIconDefinition = {
  name: 'identification',
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
  svg: `
    <path d="M4.5 19.5H19.5C20.7426 19.5 21.75 18.4926 21.75 17.25V6.75C21.75 5.50736 20.7426 4.5 19.5 4.5H4.5C3.25736 4.5 2.25 5.50736 2.25 6.75V17.25C2.25 18.4926 3.25736 19.5 4.5 19.5Z"></path>
    <path class="glm-identification-draw glm-identification-line" pathLength="1" d="M15 9H18.75"></path>
    <path class="glm-identification-draw glm-identification-line" pathLength="1" d="M15 12H18.75"></path>
    <path class="glm-identification-draw glm-identification-line" pathLength="1" d="M15 15H18.75"></path>
    <path class="glm-identification-draw glm-identification-head" pathLength="1" d="M10.5 9.375C10.5 10.4105 9.66053 11.25 8.625 11.25C7.58947 11.25 6.75 10.4105 6.75 9.375C6.75 8.33947 7.58947 7.5 8.625 7.5C9.66053 7.5 10.5 8.33947 10.5 9.375Z"></path>
    <path class="glm-identification-draw glm-identification-body" pathLength="1" d="M11.7939 15.7114C10.8489 16.2147 9.77021 16.5 8.62484 16.5C7.47948 16.5 6.40074 16.2147 5.45581 15.7114C5.92986 14.4207 7.16983 13.5 8.62484 13.5C10.0799 13.5 11.3198 14.4207 11.7939 15.7114Z"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-identification-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './identification.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IdentificationIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_IDENTIFICATION;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
